import { FunctionComponent } from 'react';

const MarkerIcon: FunctionComponent = () => (
  <svg
    width="21px"
    height="29px"
    viewBox="0 0 21 29"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-323.000000, -35.000000)" fill="#193F6A">
        <path d="M333.892451,63.3450582 C327.278694,55.0460443 323.971816,49.0598126 323.971816,45.3863632 C323.971816,39.8761891 328.413435,35.4093104 333.892451,35.4093104 C339.371466,35.4093104 343.813086,39.8761891 343.813086,45.3863632 C343.813086,49.0598126 340.506207,55.0460443 333.892451,63.3450582 Z M333.892451,47.9781022 C335.864896,47.9781022 337.463879,46.3700259 337.463879,44.3863632 C337.463879,42.4027005 335.864896,40.7946242 333.892451,40.7946242 C331.920005,40.7946242 330.321022,42.4027005 330.321022,44.3863632 C330.321022,46.3700259 331.920005,47.9781022 333.892451,47.9781022 Z"></path>
      </g>
    </g>
  </svg>
);

export default MarkerIcon;
